/**
 * Effect ID allocator — Phase 4 monotonic counter for effect identity.
 *
 * Standalone module with no imports so it can be safely imported by both
 * `lifecycle.ts` (V1 effects) and `reactive-v2.ts` (V2 EffectRecord) without
 * creating a cycle.
 *
 * IDs are 32-bit unsigned integers. 0 is reserved as the "empty slot" sentinel
 * in dense typed arrays (PackedDepSet) and as the "no effect" comparison value.
 *
 * `reactive-v2.ts` re-exports `nextEffectId` / `__resetEffectId` from this
 * module so existing V2 call sites (and tests that call `__resetEffectId`)
 * continue to work unchanged.
 */

let _nextId = 1

export function allocateEffectId(): number {
    return _nextId++
}

/** Alias used by V2 EffectRecord factory — same counter, different name for legacy reasons. */
export function nextEffectId(): number {
    return _nextId++
}

/** @internal — test-only reset. */
export function resetEffectIdForTest(): void {
    _nextId = 1
}

/** @internal — alias for V2 test code that calls `__resetEffectId`. */
export function __resetEffectId(): void {
    _nextId = 1
}
